module.exports = __webpack_public_path__ + "img/gyoza_fried.bf16a1e5.jpg";